import { Component, OnInit } from '@angular/core';
import { UserService } from '../service/apiservice/user.service';
import { LoginService } from '../service/apiservice/login.service';
import { Globals } from '../globals';
import { Router } from '@angular/router';
import { UtilFunctions } from '../util-functions';

import { SessionUser } from '../service/modal/user';
declare function info_noti(msg:any):any;
declare var $;
@Component({
  selector: 'app-add-transction-password',
  templateUrl: './add-transction-password.component.html',
  styleUrls: ['./add-transction-password.component.css']
})
export class AddTransctionPasswordComponent implements OnInit {

  constructor(private loginService:LoginService,private global:Globals,private router:Router) { }

  ngOnInit() {
    localStorage.setItem("Active Route",this.router.url);
  }
  addTranscationalPassword(password){
    this.loginService.addTranscationalPassword(this.global.loggedUser.user.user_reg_id,password).subscribe((response)=>{
 info_noti("Added Privacy Password  Succesfully")
//  console.log(this.global.loggedUser);
//         this.global.loggedUser.user=new SessionUser;
//         Object.assign(this.global.loggedUser.user, response);
//        UtilFunctions.setLocalStorage('user', JSON.stringify(this.global.loggedUser));
        window.location.reload();
// this.router.navigate(['dashboard']);
      // }else{
      //    info_noti(" Not Added Privacy Password  Succesfully")
      // }
    },err=>{
      info_noti(" Not Added Privacy Password  Succesfully")
    });
   
    // Add Transcational Password

   
  }
  addtranscationpasswordEnter(event){
    this.addTranscationalPassword(event.target.value);
    $('#addTranscationPasswordBtn').focus();
  
  }
}
